import { X } from "lucide-react";

import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import debounce from "debounce";
import { Search } from "lucide-react";
import { useCallback, useEffect, useRef } from "react";

export const GlobalFilterInput = ({
  placeholder,
  value,
  onChange,
  autoFocus = false,
  className,
}: {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  autoFocus?: boolean;
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      setTimeout(() => {
        const activeElement = document.activeElement;
        const isInputAlreadyFocused =
          activeElement &&
          (activeElement.tagName === "INPUT" ||
            activeElement.tagName === "TEXTAREA");

        if (!isInputAlreadyFocused) {
          inputRef.current?.focus();
        }
      }, 100);
    }
  }, [autoFocus]);

  const debouncedSetSearch = useCallback(
    debounce((value: string) => onChange(value), 300, {
      immediate: false,
    }),
    [],
  );

  const handleClear = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    onChange("");
  };

  return (
    <div className={cn("relative w-full", className)}>
      <Input
        ref={inputRef}
        placeholder={placeholder}
        defaultValue={value}
        onChange={(e) => debouncedSetSearch(e.target.value)}
        className="pl-7 w-full"
      />
      <Search
        width={16}
        height={16}
        className="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 select-none opacity-50"
      />
      {value && (
        <X
          width={16}
          height={16}
          className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer opacity-70 hover:opacity-100"
          onClick={handleClear}
        />
      )}
    </div>
  );
};
